import {isTmc, QuoteParameters} from "../models/QuoteParameters";
import {QuoteRequest} from "../models/QuoteRequest";
import {PortfolioType} from "../../portfolio/models/Portfolio";
import {CodeAndExchange} from "../../instruments/types/CodeAndExchange";
import {HashKeyMap} from "../../js/classes/hash-map/HashKeyMap";

export type QuoteHashMap<V> = HashKeyMap<QuoteParameters, V>;

export function quoteHashMap<V>(): QuoteHashMap<V> {
    return HashKeyMap.of(quoteHashCode);
}

// We are fine to "ignore" the legs when making the hashCode for a TMC as they have unique codes anyway
export function quoteHashCode(parameters: QuoteParameters): string {
    let concat = `${parameters.code}:${parameters.exchange}:${parameters.portfolioType}`;
    if (isTmc(parameters)) {
        concat = concat + `:${parameters.opposite}`;
    }
    return concat;
}

export function buildQuoteRequest(security: CodeAndExchange, portfolioType = PortfolioType.BROKER): QuoteRequest {
    const code = security.code;
    const exchange = security.exchange;
    return {
        code,
        exchange,
        portfolioType
    };
}
